// extracted by mini-css-extract-plugin
export default {"appWrapper":"Layout_appWrapper__Kg7n5","body":"Layout_body__7ASHh"};